import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import { DASHBOARD } from "../../Auth/Routes";

const PublicRoutes = (props) => {
  const { loginRedirectRoute } = useSelector((state) => {
    return state.login;
  });
  const isUserLoggedIn = useSelector((state) => state.login.isLoginApiSuccess);

  if (isUserLoggedIn) {
    return <Redirect to={loginRedirectRoute || DASHBOARD} />;
  }

  return props.component;
};

PublicRoutes.propTypes = {
  component: PropTypes.node,
};

export default PublicRoutes;
